import React, { FC } from "react";
import { Grid as MuiGrid, GridProps } from "@mui/material";


const Grid: FC<GridProps> = (props) => {
    return <MuiGrid {...props}/>
}

export default Grid;